import './queries/read';

import { createEntity } from 'lib/resource';
import ShowStatsListens from './schema';

export default createEntity(ShowStatsListens);
